import { render, staticRenderFns } from "./CardModalSidebar.vue?vue&type=template&id=457f2306&scoped=true"
import script from "./CardModalSidebar.vue?vue&type=script&lang=js"
export * from "./CardModalSidebar.vue?vue&type=script&lang=js"
import style0 from "./CardModalSidebar.vue?vue&type=style&index=0&id=457f2306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f2306",
  null
  
)

export default component.exports